import { css } from '@emotion/css'
import { fontSize, spacing, shorthandHelper } from '@offerzen/pinata-shame'

const styles = {
  tooltipContent: css({
    margin: 0,
    width: 200,
  }),

  tooltipBadge: css({
    margin: shorthandHelper([-spacing.small, 0, 0, spacing.small]),
  }),

  countryFlagWrapper: css({
    display: 'flex',
    alignItems: 'center',
  }),

  currencyInput: css({
    marginBottom: spacing.default,
    width: '100%',
    '& input': {
      border: 0,
      padding: `${shorthandHelper([spacing.small, spacing.small, spacing.small, 42])} !important`,
      height: '100% !important',
    },
  }),

  flag: css({
    fontSize: fontSize.default,
    display: 'flex',
    marginBottom: 'auto',
    minWidth: fontSize.default,
  }),
}

export default styles
